import React, { FC, ReactElement, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import routes from '../../../config/routes';
import { useSelector } from 'react-redux';
import { getIsLoggedIn, getIsRegistrationRequired, getSponsorPages, getContentDataPartners } from '../../../stores/reducers/userData';
import { internalizationState } from '../../../stores/reducers/sections';
import cns from 'classnames';
import './exhibition-of-sponsors.sass';
import localeFieldResolver from '../../../helpers/locale-field-finder';

const ExhibitionOfSponsors: FC = (): ReactElement => {
  const history = useHistory();
  const isLoggedIn = useSelector(getIsLoggedIn);
  const isRegistrationRequired = useSelector(getIsRegistrationRequired);
  const shouldRegister = !isLoggedIn && isRegistrationRequired;
  if (shouldRegister) history.push(routes.REGISTER);

  const sponsorPages = useSelector(getSponsorPages);
  const { backendURL, partners } = useSelector(getContentDataPartners);
  const [ sponsorsStatuses, setSponsorStatuses ] = useState<Array<string>>([]);

  const { activeLangState } = useSelector(internalizationState);

  useEffect(() => {
    const statuses = partners!.reduce((acc: Array<string>, partner: any): any => {
      if (acc.indexOf(partner.size) === -1) {
        acc.push(partner.size);
      }
      return acc;
    }, [])
    setSponsorStatuses(statuses);
  }, [partners]);

  const pushRouter = (event: React.MouseEvent, sponsor: any) : void => {
    const isPageExist = sponsorPages.some((sponsorPage: any): boolean => sponsorPage.title === sponsor.title);
    if (isPageExist) {
      history.push(`${routes.SPONSOR_PAGE}?name=${sponsor.title.toLowerCase()}`);
    }
    event.preventDefault();
  }

  const renderSponsors = (sponsors: any) => sponsors.map((sponsor: any, index: number): ReactElement => (
    <div
      className={cns('sponsor', `sponsor__${sponsor.size}`)}
      key={index}
      onClick={(e) => pushRouter(e, sponsor)}
    >
      <div className="sponsor__image">
        <img className="img-responsive" src={`${backendURL}${sponsor.image}`} alt={sponsor.title} />
      </div>
      <div className={cns(`sponsor__${sponsor.size}__info`)}>
          <div className="column-info">
            <span className="sponsor-label" style={{ backgroundColor: sponsor.color }}>
              { localeFieldResolver(sponsor, 'label', activeLangState) }
            </span>
            <span className="sponsor-title">
              { localeFieldResolver(sponsor, 'title', activeLangState) }
            </span>
          </div>
      </div>
    </div>
  ));


  return (
    <>
      <div className="exhibition-of-sponsors__header">
        <div className="container">
          {/* <h1>{ localizedName('pageTitle_ru') }</h1> */}
        </div>
      </div>

      <div className="inner-section">
        <div className="container">
          {
            sponsorsStatuses && (
              sponsorsStatuses.map((status: string): ReactElement => {
                return (
                  <div className={cns('sponsors', status)} key={status}>
                    {
                      renderSponsors(partners!.filter((p: any) => p.size === status))
                    }
                  </div>
                )
              })
            )
          }
        </div>
      </div>
    </>
  )
}

export default ExhibitionOfSponsors;
